import React from 'react';
import PropTypes from 'prop-types';
import {
  TimesheetStatus as StyledTimesheetStatus,
  TimesheetMinorStatus,
  TimesheetStatusIcon,
  TimesheetStatusLabel
} from './TimesheetStatus.style';
import YPTimesheetObject from '../../yesplan_classes/YPTimesheetObject';
import SVGIcon from '../../components/SVGIcon/SVGIcon';

class TimesheetStatus extends React.Component {
  getMainStatusIcon(status) {
    if (status === YPTimesheetObject.APPROVED_STATUS) return 'seal-checkmark-fill';
    if (status === YPTimesheetObject.REJECTED_STATUS) return 'xmark-circle';
    if (status === YPTimesheetObject.FINALIZED_STATUS) return 'check';
    return false;
  }

  getStatusLabel(status) {
    switch (status) {
      case YPTimesheetObject.APPROVED_STATUS:
        return i18n('Approved');
      case YPTimesheetObject.REJECTED_STATUS:
        return i18n('Rejected');
      case YPTimesheetObject.FINALIZED_STATUS:
        return i18n('Submitted');
      case YPTimesheetObject.PENDING_STATUS:
        return i18n('Awaiting changes');
      case YPTimesheetObject.SUBMITTED_STATUS:
        return i18n('Awaiting approval');
      case YPTimesheetObject.DRAFT_STATUS:
        return i18n('Not yet submitted');
      default:
        return '';
    }
  }

  isMainStatus() {
    const { status } = this.props;
    return [
      YPTimesheetObject.APPROVED_STATUS,
      YPTimesheetObject.REJECTED_STATUS,
      YPTimesheetObject.FINALIZED_STATUS
    ].includes(status);
  }

  renderMainStatusIcon() {
    const { status } = this.props;
    return (
      <TimesheetStatusIcon
        variant={status}
        size="small"
        icon={this.getMainStatusIcon(status)}
      />
    );
  }

  renderInfoIcon() {
    return <SVGIcon size="small" icon="info" tw=" text-black text-opacity-60" />;
  }

  renderStatusBody() {
    const { status, showAsInlineMessage } = this.props;

    if (this.isMainStatus())
      return (
        <TimesheetStatusLabel $variant={status}>
          {this.getStatusLabel(status)}
        </TimesheetStatusLabel>
      );

    return (
      <TimesheetMinorStatus
        $showAsInlineMessage={showAsInlineMessage}
        $isDraftStatus={status === YPTimesheetObject.DRAFT_STATUS}
      >
        {this.getStatusLabel(status)}
      </TimesheetMinorStatus>
    );
  }

  render() {
    const { showAsInlineMessage, className } = this.props;
    return (
      <StyledTimesheetStatus data-test-timesheet-status className={className}>
        {!this.isMainStatus() && showAsInlineMessage && this.renderInfoIcon()}
        {this.renderStatusBody()}
        {this.isMainStatus() && this.renderMainStatusIcon()}
      </StyledTimesheetStatus>
    );
  }
}

TimesheetStatus.propTypes = {
  status: PropTypes.oneOf([
    YPTimesheetObject.APPROVED_STATUS,
    YPTimesheetObject.REJECTED_STATUS,
    YPTimesheetObject.FINALIZED_STATUS,
    YPTimesheetObject.PENDING_STATUS,
    YPTimesheetObject.SUBMITTED_STATUS,
    YPTimesheetObject.DRAFT_STATUS
  ]).isRequired,
  showAsInlineMessage: PropTypes.bool,
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string
};

TimesheetStatus.defaultProps = {
  showAsInlineMessage: false,
  className: ''
};

export default TimesheetStatus;
